// Fatura Girişi satırı için canlı birim-dönüşüm önizlemesi.
//
// Backend (finance.py:497-510) bir kalemi kaydederken, seçilen giriş birimi için
// aktif bir BirimDonusum varsa VE o dönüşümün stok_birimi malzemenin birimine
// eşitse şunu uygular:
//     stok_miktar      = miktar * katsayi
//     stok_birim_fiyat = net_birim_fiyat / katsayi
// Bu hesabı kullanıcıya satırda canlı gösterip "yanlış birimde miktar girme"
// hatasını (örn. KOLI seçiliyken kg değeri) kaydetmeden önce görünür kılarız.

// Backend birim_donusum_service.normalize_birim ile birebir aynı alias tablosu.
const UNIT_ALIASES = {
  AD: 'ADET', ADET: 'ADET', 'AD.': 'ADET',
  LT: 'LITRE', LITRE: 'LITRE', L: 'LITRE',
  KG: 'KG', KILO: 'KG', KILOGRAM: 'KG',
  GR: 'GR', GRAM: 'GR', G: 'GR',
  ML: 'ML', MILLILITRE: 'ML',
  PORSIYON: 'PORSIYON', POR: 'PORSIYON', 'POR.': 'PORSIYON',
  PAKET: 'PAKET', PKT: 'PAKET',
  KOLI: 'KOLI', KASA: 'KASA',
};

export function normalizeBirim(birim) {
  if (!birim) return '';
  const cleaned = String(birim).toUpperCase().trim();
  return UNIT_ALIASES[cleaned] || cleaned;
}

const round4 = (n) => Math.round((n + Number.EPSILON) * 10000) / 10000;

/**
 * @returns null  → dönüşüm uygulanmaz (önizlenecek bir şey yok)
 *          {alisBirim, stokBirim, katsayi, stokMiktar, stokBirimFiyat} → backend'in yazacağı stok-birim değerleri
 */
export function donusumOnizleme({ miktar, birim, netFiyat, malzemeBirim, bdList }) {
  const m = Number(miktar);
  if (!m || m <= 0) return null;
  if (!birim || !Array.isArray(bdList) || bdList.length === 0) return null;

  const nGiris = normalizeBirim(birim);
  const nStok = normalizeBirim(malzemeBirim);
  // Birim zaten stok birimi ise dönüşüm gerekmez (kullanıcı doğru birimde).
  if (nGiris === nStok) return null;

  const bd = bdList.find(
    (d) =>
      d &&
      d.aktif !== false &&
      normalizeBirim(d.alis_birimi) === nGiris &&
      // Backend guard'ı: yalnız BD stok birimine çeviriyorsa uygula
      // (reçete-amaçlı BD'ler fiyat girişinde uygulanmaz).
      normalizeBirim(d.stok_birimi) === nStok
  );
  if (!bd || !bd.katsayi) return null;

  const katsayi = Number(bd.katsayi);
  const net = Number(netFiyat);
  return {
    alisBirim: bd.alis_birimi,
    stokBirim: bd.stok_birimi,
    katsayi,
    stokMiktar: round4(m * katsayi),
    stokBirimFiyat: net > 0 ? round4(net / katsayi) : null,
  };
}
